import * as React from "react";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

//MUI
import Icon from "@mui/material/Icon";
import Typography from "@mui/material/Typography";

//Custom components
import { GridContainer, GridItem } from "@/ui/Grid";

//Types
import { IIconView } from "@/@types/ui/Form";

const IconView: FunctionComponent<IIconView> = (props) => {
  const { t } = useTranslation();
  const { icon, value, title, suffix } = props;

  return (
    <GridContainer>
      {icon ? (
        <GridItem>
          <Icon color="primary">{icon}</Icon>
        </GridItem>
      ) : null}
      <GridItem>
        <Typography>
          {t(title)}
          {value ? ":" : ""}
        </Typography>
      </GridItem>
      {value ? (
        <GridItem>
          <Typography>
            <b>
              {value}
              {suffix ? suffix : ""}{" "}
            </b>
          </Typography>
        </GridItem>
      ) : null}
    </GridContainer>
  );
};

export default IconView;
